// Flip-clock countdown for the announcement bar. End time is rendered
// server-side (data-end, epoch seconds in the store's timezone) and ticked
// down using Date.now() elapsed time only, so it never trusts or can be
// skewed by the visitor's device clock (same pattern as countdown-promo-bar.js).
(function () {
  function setupCountdown(root) {
    var endSeconds = parseInt(root.dataset.end, 10);
    var nowSeconds = parseInt(root.dataset.now, 10);
    var pageLoadMs = Date.now();
    var expiredAction = root.dataset.expired;
    var expiredMessage = root.dataset.expiredMessage || '';

    var label = root.querySelector('[data-acb-label]');
    var clock = root.querySelector('[data-acb-clock]');
    var units = {
      days: root.querySelectorAll('[data-acb-unit="days"] [data-acb-digit]'),
      hours: root.querySelectorAll('[data-acb-unit="hours"] [data-acb-digit]'),
      minutes: root.querySelectorAll('[data-acb-unit="minutes"] [data-acb-digit]'),
      seconds: root.querySelectorAll('[data-acb-unit="seconds"] [data-acb-digit]'),
    };

    function setDigits(tiles, value) {
      var str = String(Math.max(0, value)).padStart(2, '0').slice(-2);
      for (var i = 0; i < tiles.length; i++) {
        var next = str[i];
        if (tiles[i].textContent === next) continue;
        var tile = tiles[i];
        tile.classList.add('is-flipping');
        setTimeout(function (el, digit) {
          return function () {
            el.textContent = digit;
          };
        }(tile, next), 160);
        setTimeout(function (el) {
          return function () {
            el.classList.remove('is-flipping');
          };
        }(tile), 320);
      }
    }

    function tick() {
      var elapsedSeconds = Math.floor((Date.now() - pageLoadMs) / 1000);
      var secondsLeft = endSeconds - nowSeconds - elapsedSeconds;

      if (secondsLeft <= 0) {
        if (expiredAction === 'hide') {
          root.hidden = true;
        } else if (expiredAction === 'message' && label) {
          clock.hidden = true;
          label.textContent = expiredMessage;
        } else {
          setDigits(units.days, 0);
          setDigits(units.hours, 0);
          setDigits(units.minutes, 0);
          setDigits(units.seconds, 0);
        }
        clearInterval(intervalId);
        return;
      }

      var days = Math.floor(secondsLeft / 86400);
      var hours = Math.floor((secondsLeft % 86400) / 3600);
      var minutes = Math.floor((secondsLeft % 3600) / 60);
      var seconds = Math.floor(secondsLeft % 60);

      setDigits(units.days, days);
      setDigits(units.hours, hours);
      setDigits(units.minutes, minutes);
      setDigits(units.seconds, seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
  }

  function scan() {
    document.querySelectorAll('[data-acb-countdown]').forEach(function (root) {
      if (root.dataset.acbInit) return;
      root.dataset.acbInit = 'true';
      setupCountdown(root);
    });
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
